import { Serializable } from './Serializable';

export class EnumDTO extends Serializable {
    id: number;
    value: string;
    
    constructor() {
        super();
    }
    
    get getValueTranslate() {
        return "'ENUMS." + this.value + "' | translate"
    }

}
